<template>
  <Alert v-if="affectedDependents.length" theme="warning" class="affected-shops">
    {{ $t('productUpdateAffectedProducts', { shops: affectedShops.length, products: affectedDependents.length }) }}
    <DropdownComponent>
      <template #default>
        <ButtonComponent :label="$t('showOverview')" :icon="['fal', 'angle-down']" class="text--small" />
      </template>
      <template #dropdown>
        <ButtonComponent
          :label="item.location"
          v-for="(item, index) in affectedDependents"
          :key="index"
          tag="router-link"
          :icon="['fal', 'external-link']"
          target="_blank"
          :to="{ name: 'shop-mutate', params: { id: item.shop } }"
        />
      </template>
    </DropdownComponent>
  </Alert>
</template>

<script>
import { AlertComponent as Alert } from 'vue-elder-alert'
import { DropdownComponent } from 'vue-elder-dropdown'
import { SortByKey } from '@/utils'

export default {
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
  },
  inject: ['getData'],
  computed: {
    affectedShops() {
      return Array.from(new Set(this.affectedDependents.map(e => e.shop)))
    },
    affectedDependents() {
      if (!this.item.dependents || !this.getData) return []
      let keys = Object.keys(this.getData({ diff: true }))
      return this.item.dependents.filter(d => keys.some(k => !d.overrides.includes(k))).sort(SortByKey('location'))
    },
  },
  components: {
    Alert,
    DropdownComponent,
  },
}
</script>

<style lang="scss">
.affected-shops {
  .elder-button {
    --vue-elder-button-padding-y: 0;
    --vue-elder-button-padding-x: 0;

    border: none;
    text-decoration: underline;

    &:hover:before {
      opacity: 0 !important;
    }

    &__icon {
      margin-left: 0.5rem;
    }
  }

  .alert__content {
    padding-block: 1.1em;

    &:before {
      border-radius: var(--border-radius);
    }

    & > span {
      display: flex;
      align-items: center;
      gap: 1rem;
    }
  }
}
</style>
